import { render, staticRenderFns } from "./AccProductTemplateCreateModal.vue?vue&type=template&id=6c7f7a66"
import script from "./AccProductTemplateCreateModal.vue?vue&type=script&lang=js"
export * from "./AccProductTemplateCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports